import React, { useState } from "react";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage, db } from "../Firebase";
import { addDoc, collection } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth"; // Import Firebase Auth
import "./UploadTemplatePage.css"; // Importing the updated CSS

function UploadTemplate() {
  const [file, setFile] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadError, setUploadError] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth(); // Initialize Firebase Auth
  const user = auth.currentUser; // Get the current logged-in user

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    // Validate the file extension to be .docx only
    if (selectedFile && selectedFile.name.endsWith(".docx")) {
      setFile(selectedFile);
      setUploadProgress(0); // Reset progress bar on new file selection
      setUploadSuccess(false);
      setUploadError("");
    } else {
      setUploadError("Please select a valid .docx file.");
    }
  };

  const handleUpload = () => {
    if (!file) {
      setUploadError("Please select a file before uploading.");
      return;
    }

    if (!user) {
      setUploadError("You need to be logged in to upload a template.");
      return;
    }

    setIsUploading(true);
    const storageRef = ref(storage, `templates/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadProgress(progress);
      },
      (error) => {
        console.error("Upload failed:", error);
        setUploadError("Upload failed. Please try again.");
        setIsUploading(false);
      },
      async () => {
        try {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          await addDoc(collection(db, "templates"), {
            name: file.name,
            url: downloadURL,
            userId: user.uid, // Add the userId field with the current user's UID
          });
          setUploadSuccess(true);
          setFile(null);
          setIsUploading(false);
          navigate("/dashboard");
        } catch (error) {
          console.error("Error saving template metadata:", error);
          setUploadError("Failed to save template metadata. Please try again.");
          setIsUploading(false);
        }
      }
    );
  };

  return (
    <div className="upload-template-container">
      <div className="upload-template-box">
        <h1>Upload a Template</h1>
        <p>
          Upload a letter template with placeholders for dynamic data to be
          input by magic! *Must be a .docx document*
        </p>
        <input type="file" accept=".docx" onChange={handleFileChange} />
        {file && (
          <button
            className="upload-button"
            onClick={handleUpload}
            disabled={isUploading}
          >
            {isUploading ? "Uploading..." : "Upload Template"}
          </button>
        )}
        {uploadProgress > 0 && (
          <div className="progress-bar">
            <div
              className="progress"
              style={{ width: `${uploadProgress}%` }}
            ></div>
          </div>
        )}
        {uploadSuccess && <p className="success-message">Upload successful!</p>}
        {uploadError && <p className="error-message">{uploadError}</p>}
      </div>

      {/* Placeholder Information Box */}
      <div className="placeholder-box">
        <p>
          <strong>Placeholders for dynamic data:</strong>
        </p>
        <p>{`{todaysDate}, {houseNumber}, {roadName}, {town}, {county}, {postcode}, {weeksOnMarket}, {agent}`}</p>
      </div>
    </div>
  );
}

export default UploadTemplate;
